<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div class="">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="订单搜索：">
              <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="订单类型：">
              <el-select v-model="searchForm.deliveryType" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in deliveryTypeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间筛选：">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="秒杀活动：">
              <el-select v-model="searchForm.secKillId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in secKillIdArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="秒杀商品：">
              <el-select v-model="searchForm.secKillGoodsId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in secKillGoodsIdArr"
                  :key="item.id"
                  :label="item.goodsName"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
              <el-button v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div>
        <el-table
          :data="infoList"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="deliveryType"
            label="订单类型">
            <template slot-scope="scope">
              <span>{{scope.row.deliveryType == 1 ? '自提订单' : '配送订单'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="goodsOrderGoodsList"
            width="450"
            label="商品信息">
            <template slot-scope="scope">
              <div class="" v-for="(item,index) in scope.row.goodsOrderGoodsList" :key="index">
                <el-image
                  style="width: 32px;"
                  :src="item.thumb"
                  :preview-src-list="[item.thumb]"
                  fit="contain">
                  </el-image>
                  <span>{{item.goodsName}}-{{item.specName}}</span>
                  <span>x{{item.goodsNumber}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderMoney"
            label="订单金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="realPayMoney"
            label="支付金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="paySuccessTime"
            label="支付时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderStatusText"
            label="订单状态">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { querySecKillOrderPageList, queryAllSecKillGoodsList, queryAllSecKillList } from '@/api/seckill'
export default {
  name: 'SeckillOrder',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        deliveryType:'',
        date:['', ''],
        secKillId:'',
        secKillGoodsId:'',
      },
      deliveryTypeArr:[{
        value:1,
        label:'自提订单'
      }, {
        value:0,
        label:'配送订单'
      }],
      secKillIdArr:[],
      secKillGoodsIdArr:[],
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:''
    }
  },
  mounted () {
    var that = this;
    that.getInfoList();
  },
  created() {
    this.secKillIdArrFun();
    this.secKillGoodsIdArrFun();
  },
  methods: {
    // 订单列表-获取秒杀活动列表
    secKillIdArrFun(){
      var that = this;
      queryAllSecKillList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.secKillIdArr = data
        }
        if (res.errorCode === '4002') {
          that.secKillIdArr = []
        }
      })
    },
    // 订单列表-获取秒杀商品列表
    secKillGoodsIdArrFun(){
      var that = this;
      queryAllSecKillGoodsList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.secKillGoodsIdArr = data
        }
        if (res.errorCode === '4002') {
          that.secKillGoodsIdArr = []
        }
      })
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let deliveryType = that.searchForm.deliveryType
      let searchName = that.searchForm.name
      let secKillId = that.searchForm.secKillId
      let secKillGoodsId = that.searchForm.secKillGoodsId
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      querySecKillOrderPageList({ webSearchStr: searchName, deliveryType: deliveryType, startDate: startDate, endDate: endDate, secKillId: secKillId, secKillGoodsId: secKillGoodsId, pageNum: page, pageSize: that.limitLength }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/seckill/SeckillOrder.vue